var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "下载资料",
        width: "720px",
        footer: null
      },
      on: { cancel: _vm.handleCancel }
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._v("\n    资料已审核并制作完成，"),
          _c("span", { staticClass: "red" }, [
            _vm._v(
              "请在一个工作日内下载完整资料包（请勿修改资料包文件名），并将完整的注册资料包发送到服务邮箱"
            )
          ]),
          _vm._v("。如有疑问，请咨询在线客服或客户经理，感谢配合！\n    "),
          _c("br"),
          _vm._v("\n    步骤1: 下载资料，\n    "),
          _vm._v(" "),
          typeof _vm.item.customerData === "string"
            ? _c(
                "a",
                {
                  attrs: {
                    href: _vm.item.customerData,
                    download: _vm.item.customerData,
                    target: "_blank"
                  },
                  on: {
                    click: function($event) {
                      return _vm.customerDataDownLoad(_vm.item)
                    }
                  }
                },
                [
                  _vm._v("点击下载"),
                  _c("a-icon", {
                    staticClass: "icon",
                    attrs: { type: "download" }
                  })
                ],
                1
              )
            : _vm._l(_vm.item.customerDataList, function(o, i) {
                return _c(
                  "a",
                  {
                    key: i,
                    attrs: {
                      href: o.fileUrl,
                      download: o.fileUrl,
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(_vm._s(o.fileRemark)),
                    _c("a-icon", {
                      staticClass: "icon",
                      attrs: { type: "download" }
                    })
                  ],
                  1
                )
              }),
          _vm._v(" "),
          _vm.item.fileUrl
            ? _c(
                "a",
                {
                  attrs: {
                    href: _vm.item.fileUrl,
                    download: _vm.item.fileUrl,
                    target: "_blank"
                  }
                },
                [
                  _vm._v(_vm._s(_vm.item.fileRemark)),
                  _c("a-icon", {
                    staticClass: "icon",
                    attrs: { type: "download" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.designPatentWorkOrder
            ? [
                _vm.item.designPatentWorkOrder.customerRegisterData
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href:
                            _vm.item.designPatentWorkOrder.customerRegisterData,
                          download:
                            _vm.item.designPatentWorkOrder.customerRegisterData,
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v("注册资料"),
                        _c("a-icon", {
                          staticClass: "icon",
                          attrs: { type: "download" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.designPatentWorkOrder.customerOaReplyData
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href:
                            _vm.item.designPatentWorkOrder.customerOaReplyData,
                          download:
                            _vm.item.designPatentWorkOrder.customerOaReplyData,
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v("OA答复资料"),
                        _c("a-icon", {
                          staticClass: "icon",
                          attrs: { type: "download" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n    步骤2: 将注册资料发送至服务邮箱： "),
          _c("a", { attrs: { href: "mailto:" + _vm.email } }, [
            _vm._v(_vm._s(_vm.email))
          ]),
          _c(
            "span",
            {
              directives: [
                {
                  name: "copy",
                  rawName: "v-copy",
                  value: _vm.email,
                  expression: "email"
                }
              ],
              staticClass: "copy-email"
            },
            [_vm._v("复制邮箱地址")]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "footer" },
        [
          !_vm.emailSendStatus
            ? _c(
                "a-popconfirm",
                {
                  attrs: {
                    title: "是否确认提交？",
                    "ok-text": "确定",
                    "cancel-text": "取消"
                  },
                  on: { confirm: _vm.handleEmailSend }
                },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", disabled: _vm.emailSendStatus }
                    },
                    [_vm._v("我已发送")]
                  )
                ],
                1
              )
            : _c(
                "a-button",
                { attrs: { type: "primary", disabled: _vm.emailSendStatus } },
                [_vm._v("我已发送")]
              )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4cf10dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4cf10dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./xcloud-client-components-web/module/components/sendDataDialog.vue
// module id = null
// module chunks = 